// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as LiveRouteImport } from './routes/live'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as StoriesIndexRouteImport } from './routes/stories.index'
import { Route as QuotesIndexRouteImport } from './routes/quotes.index'
import { Route as GlossaryIndexRouteImport } from './routes/glossary.index'
import { Route as GamesIndexRouteImport } from './routes/games.index'
import { Route as StoriesSlugRouteImport } from './routes/stories.$slug'
import { Route as QuotesSlugRouteImport } from './routes/quotes.$slug'
import { Route as GlossarySlugRouteImport } from './routes/glossary.$slug'
import { Route as GamesGuessAuthorRouteImport } from './routes/games.guess-author'
import { Route as GamesSlugRouteImport } from './routes/games.$slug'
import { Route as GamesSlugIndexRouteImport } from './routes/games.$slug.index'
import { Route as GamesSlugPlayRouteImport } from './routes/games.$slug.play'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const LiveRoute = LiveRouteImport.update({
            id: '/live',path: '/live',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const StoriesIndexRoute = StoriesIndexRouteImport.update({
            id: '/stories/',path: '/stories/',getParentRoute: () => rootRouteImport
          })
const QuotesIndexRoute = QuotesIndexRouteImport.update({
            id: '/quotes/',path: '/quotes/',getParentRoute: () => rootRouteImport
          })
const GlossaryIndexRoute = GlossaryIndexRouteImport.update({
            id: '/glossary/',path: '/glossary/',getParentRoute: () => rootRouteImport
          })
const GamesIndexRoute = GamesIndexRouteImport.update({
            id: '/games/',path: '/games/',getParentRoute: () => rootRouteImport
          })
const StoriesSlugRoute = StoriesSlugRouteImport.update({
            id: '/stories/$slug',path: '/stories/$slug',getParentRoute: () => rootRouteImport
          })
const QuotesSlugRoute = QuotesSlugRouteImport.update({
            id: '/quotes/$slug',path: '/quotes/$slug',getParentRoute: () => rootRouteImport
          })
const GlossarySlugRoute = GlossarySlugRouteImport.update({
            id: '/glossary/$slug',path: '/glossary/$slug',getParentRoute: () => rootRouteImport
          })
const GamesGuessAuthorRoute = GamesGuessAuthorRouteImport.update({
            id: '/games/guess-author',path: '/games/guess-author',getParentRoute: () => rootRouteImport
          })
const GamesSlugRoute = GamesSlugRouteImport.update({
            id: '/games/$slug',path: '/games/$slug',getParentRoute: () => rootRouteImport
          })
const GamesSlugIndexRoute = GamesSlugIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => GamesSlugRoute
          })
const GamesSlugPlayRoute = GamesSlugPlayRouteImport.update({
            id: '/play',path: '/play',getParentRoute: () => GamesSlugRoute
          })





const GamesSlugRouteChildren = {
  GamesSlugPlayRoute: GamesSlugPlayRoute,GamesSlugIndexRoute: GamesSlugIndexRoute
}

const GamesSlugRouteWithChildren = GamesSlugRoute._addFileChildren(GamesSlugRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,LiveRoute: LiveRoute,PrivacyRoute: PrivacyRoute,TermsRoute: TermsRoute,GamesSlugRoute: GamesSlugRouteWithChildren,GamesGuessAuthorRoute: GamesGuessAuthorRoute,GlossarySlugRoute: GlossarySlugRoute,QuotesSlugRoute: QuotesSlugRoute,StoriesSlugRoute: StoriesSlugRoute,GamesIndexRoute: GamesIndexRoute,GlossaryIndexRoute: GlossaryIndexRoute,QuotesIndexRoute: QuotesIndexRoute,StoriesIndexRoute: StoriesIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)